exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b816406c] .el-card__body{height:100%}[data-v-b816406c] .el-icon-arrow-right{display:none}.add-related-btn[data-v-b816406c]{border:1px dashed var(--lineBorderColor);color:1px dashed var(--lineBorderColor);margin:0 0 20px 130px;padding:4px 0;font-size:14px;cursor:pointer}.add-related-line[data-v-b816406c]{height:0;border-top:1px dashed var(--lineBorderColor);margin:0 0 20px 30px}", ""]);

// exports
